import Query from '../../../components/Report';

const query = new Query('search-stats-position-distribution');

export default query;
